export enum RoleUsuario {
    ADMIN = 1,
    SECRETARIA = 2,
    AFILIADO = 3,
    ADMINISTRADOR_AFILIADO = 5,
}
